module.exports = __webpack_public_path__ + "static/media/spaceShooter2Ddavide.eec62487.jpg";